<template>
	<div class="menus-wrap" style="border: 1px solid #eee;">
	<template>
		<div class="wrap">
			<h1>请填写行程信息</h1>
			<p class="tip">带*为必填内容，在需要填写数字的输入框内，请使用半角数字。</p>
			<p class="line"></p>
			<el-form :model="form" :rules="rules" ref="formRef">
				<!-- 详细信息 -->
				<template v-for="(item, index) in form.details">
					<!-- 输入框 -->
					<template v-if="item.type == 1 && item.is_required == 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'blur' }"
						>
							<el-input v-model="item.value" :maxlength="item.length && item.length !== '0' ? item.length : ''" :placeholder="item.tips"></el-input>
						</el-form-item>
					</template>
					<template v-else-if="item.type == 1 && item.is_required != 1">
						<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
							<el-input v-model="item.value" :maxlength="item.length && item.length !== '0' ? item.length : ''" :placeholder="item.tips"></el-input>
						</el-form-item>
					</template>

					<!-- 文本域 -->
					<template v-if="item.type == 2 && item.is_required == 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'blur' }"
						>
							<el-input
								type="textarea"
								v-model="item.value"
								resize="none"
								:autosize="{ minRows: 6, maxRows: 6 }"
								:maxlength="item.length && item.length !== '0' ? item.length : ''"
								:placeholder="item.tips"
							></el-input>
						</el-form-item>
					</template>
					<template v-else-if="item.type == 2 && item.is_required != 1">
						<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
							<el-input
								type="textarea"
								v-model="item.value"
								resize="none"
								:autosize="{ minRows: 6, maxRows: 6 }"
								:maxlength="item.length && item.length !== '0' ? item.length : ''"
								:placeholder="item.tips"
							></el-input>
						</el-form-item>
					</template>

					<!-- 选择器 -->
					<template v-if="item.type == 3 && item.is_required == 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
						>
							<template v-if="item.name === '民族'">
								<el-select v-model="item.value" :placeholder="item.tips">
									<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
								</el-select>
							</template>
							<template v-else>
								<el-select v-model="item.value" :placeholder="item.tips">
									<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
								</el-select>
							</template>
						</el-form-item>
					</template>
					<template v-else-if="item.type == 3 && item.is_required != 1">
						<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
							<template v-if="item.name === '民族'">
								<el-select v-model="item.value" :placeholder="item.tips">
									<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
								</el-select>
							</template>
							<template v-else>
								<el-select v-model="item.value" :placeholder="item.tips">
									<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
								</el-select>
							</template>
						</el-form-item>
					</template>

					<!-- 选择器（多选） -->
					<template v-if="item.type == 4 && item.is_required == 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
						>
							<template v-if="item.name === '民族'">
								<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
									<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
								</el-select>
							</template>
							<template v-else>
								<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
									<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
								</el-select>
							</template>
						</el-form-item>
					</template>
					<template v-else-if="item.type == 4 && item.is_required != 1">
						<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
							<template v-if="item.name === '民族'">
								<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
									<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
								</el-select>
							</template>
							<template v-else>
								<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
									<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
								</el-select>
							</template>
						</el-form-item>
					</template>

					<!-- 文件上传 -->
					<template v-if="item.type == 5 && item.is_required == 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
						>
							<template v-if="item.name === '渝康码'">
								<upload-file
									:multiple="true"
									path="xcyukang"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
							<template v-else-if="item.name === '行程码'">
								<upload-file
									:multiple="true"
									path="xcxc"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
							<template v-else-if="item.name === '核酸检测报告'">
								<upload-file
									:multiple="true"
									path="xchesuan"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
							<template v-else>
								<upload-file
									:multiple="true"
									path="xcelse"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
						</el-form-item>
					</template>
					<template v-else-if="item.type == 5 && item.is_required != 1">
						<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
							<template v-if="item.name === '渝康码'">
								<upload-file
									:multiple="true"
									path="xcyukang"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
							<template v-else-if="item.name === '行程码'">
								<upload-file
									:multiple="true"
									path="xcxc"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
							<template v-else-if="item.name === '核酸检测报告'">
								<upload-file
									:multiple="true"
									path="xchesuan"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
							<template v-else>
								<upload-file
									:multiple="true"
									path="xcelse"
									:name="item.name"
									@add:files="
										val => {
											item.value.push(val);
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
									@del:files="
										fileList => {
											item.value = fileList;
											$refs.formRef.validateField('details.' + index + '.value');
										}
									"
								></upload-file>
							</template>
						</el-form-item>
					</template>

					<!-- 日期选择器 -->
					<template v-if="item.type == 6 && item.is_required == 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
						>
							<el-date-picker v-model="item.value" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
						</el-form-item>
					</template>
					<template v-else-if="item.type == 6 && item.is_required != 1">
						<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
							<el-date-picker v-model="item.value" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
						</el-form-item>
					</template>

					<!-- 手机号 -->
					<template v-if="item.type == 7 && item.is_required == 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="[
								{
									validator: validatePhone,
									trigger: 'blur'
								},
								{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'blur' }
							]"
						>
							<el-input
								v-model="item.value"
								maxlength="11"
								@input="
									() => {
										item.value = item.value.replace(/[^\d]/g, '');
									}
								"
								:placeholder="item.tips"
							></el-input>
						</el-form-item>
					</template>
					<template v-else-if="item.type == 7 && item.is_required != 1">
						<el-form-item
							:label="item.name"
							:prop="'details.' + index + '.value'"
							:rules="{
									validator: validatePhone,
									trigger: 'blur'
								},"
						>
							<el-input
								v-model="item.value"
								maxlength="11"
								@input="
									() => {
										item.value = item.value.replace(/[^\d]/g, '');
									}
								"
								:placeholder="item.tips"
							></el-input>
						</el-form-item>
					</template>
				</template>
			</el-form>
			<div class="footer-btns"><el-button type="primary" @click="onSubmit()">提交行程</el-button></div>
		</div>
	</template>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import UploadFile from '@/components/UploadFile';
import nation from '@/assets/nation.json';
import { validateCardID, validatePhone } from '@/tools/validate';
import { getNowFormatDate, GetAge } from '@/tools';
import { reqGetUserInfo, reqShowAddTravel, reqAddTravel } from '@/api';
export default {
	components: {
		UploadFile
	},
	data() {
		return {
			nation,
			validatePhone,
			// 默认信息表单
			form: {
				details: []
			}
		};
	},
	computed: {
		...mapState({
			id: state => state.user.examinee.id,
			do_travel: state => state.user.examinee.do_travel,
			card_id: state => state.user.examinee.card_id,
			name: state => state.user.examinee.name,
			examination_id: state => state.system.examInfo.examination_id,
			regist_end_time: state => state.system.examInfo.regist_end_time,
			company_id: state => state.system.company_id
		})
	},
	mounted() {
		this.getShowDatas();
	},
	methods: {
		// 获取考生详情
		getDetail() {
			reqGetUserInfo().then(res => {
				console.log(res.data);
				this.id = res.data.id;
				this.card_id = res.data.card_id;
			});
		},
		// 获取回显信息(行程表单)
		getShowDatas() {
			reqShowAddTravel({
				company_id: this.company_id,
				examination_id: this.examination_id
			}).then(res => {
				this.form.details = res.data.form.map(v => {
					return {
						...v,
						value: v.type === 4 || v.type === 5 ? [] : ''
					};
				});
			});
		},
		// 提交行程
		onSubmit() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					reqAddTravel({
						id: this.id,
						card_id: this.card_id,
						name: this.name,
						company_id: this.company_id,
						examination_id: this.examination_id,
						...this.form,
					}).then(res => {
						this.$store.commit('user/SET_DO_TRAVEL', 2);
						this.$router.push('/travel');
					});
				} else {
					return false;
				}
			});
		},
		disabledDate(date) {
			return new Date().getTime() < new Date(date).getTime();
		}
	}
};
</script>

<style lang="scss" scoped>
.wrap {
	h1 {
		font-size: 20px;
		font-weight: bold;
		color: #000;
		text-align: center;
	}

	.tip {
		font-size: 16px;
		color: #ff070a;
		text-align: center;
	}

	.line {
		border: 1px solid #e5e5e5;
		margin: 12px 0;
	}

	.el-form {
		width: 600px;
		margin: 0 auto;
		padding-right: 10px;

		.el-select,
		.el-date-editor {
			width: 100%;
		}
	}
}
</style>
